/**
 * Countdown for the advertorial announcement bar.
 *
 * Standalone because the site header (which carries the theme's own countdown) is
 * hidden on advertorial pages, and that timer's script is inline in header.liquid
 * rather than a shared asset.
 *
 * Markup contract mirrors the header's, so the two read the same in the DOM:
 *   [data-adv-cd] with data-adv-cd-target="<ISO8601>" and data-adv-cd-done="<text>"
 *   children [data-adv-cd="days|hours|minutes|seconds"]
 *
 * v2: hides the DAYS unit (and its separator) while the countdown is under 24h,
 * so a short timer does not read "00 DAYS". v1 computed days but the bar markup
 * had no slot for them, so a multi-day target silently displayed only the
 * hours-within-the-current-day.
 */
(function () {
  var roots = document.querySelectorAll('[data-adv-cd]');
  if (!roots.length) return;

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function paint(root) {
    var target = Date.parse(root.getAttribute('data-adv-cd-target'));
    if (isNaN(target)) return true; // unparseable date: leave the markup alone

    var left = target - Date.now();

    if (left <= 0) {
      var done = root.getAttribute('data-adv-cd-done');
      if (done) root.textContent = done;
      return true; // finished — stop ticking
    }

    var s = Math.floor(left / 1000);
    var parts = {
      days: Math.floor(s / 86400),
      hours: Math.floor((s % 86400) / 3600),
      minutes: Math.floor((s % 3600) / 60),
      seconds: s % 60
    };

    Object.keys(parts).forEach(function (k) {
      var el = root.querySelector('[data-adv-cd="' + k + '"]');
      if (el) el.textContent = pad(parts[k]);
    });

    // Drop the days unit once it would read zero, rather than showing "00 DAYS".
    var dayUnit = root.querySelector('[data-adv-cd-dayunit]');
    if (dayUnit) dayUnit.hidden = parts.days === 0;
    var daySep = root.querySelector('[data-adv-cd-daysep]');
    if (daySep) daySep.hidden = parts.days === 0;

    return false;
  }

  function tick() {
    var allDone = true;
    Array.prototype.forEach.call(roots, function (root) {
      if (!paint(root)) allDone = false;
    });
    if (!allDone) setTimeout(tick, 1000);
  }

  tick();
})();
